import { Avatar, Box, type Theme, Typography, styled } from "@mui/material";

import { getInitialsFromName } from "@/utils/user-utils";

import { formatPhoneNumber } from "../utils/accountUtils";

interface AccountInfoDBCProps {
  photo: string;
  name: string;
  email: string;
  phone: string;
}

const AvatarContent = styled(Box)(({ theme }: { theme: Theme }) => ({
  textAlign: "center",
  verticalAlign: "middle",
  padding: "16px",
  [theme.breakpoints.between("xs", "sm")]: {
    height: "100%",
    width: "100%",
  },
}));

const StyledAvatar = styled(Avatar)(({ theme }: { theme: Theme }) => ({
  width: "160px",
  height: "160px",
  fontSize: "56px",
  margin: "20px auto",
  [theme.breakpoints.between("xs", "sm")]: {
    marginBottom: "16px auto",
  },
}));

const AvatarInfo = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.white,
  marginBottom: "8px",
  wordBreak: "break-word",
}));

export default function AccountInfoDBC({ photo, name, email, phone }: AccountInfoDBCProps) {
  const nameInitials = getInitialsFromName(name);
  return (
    <AvatarContent>
      <StyledAvatar src={photo} data-testid="account-preview-avatar">
        {nameInitials}
      </StyledAvatar>
      <AvatarInfo variant="h6" sx={{ fontWeight: "bold" }}>
        {name}
      </AvatarInfo>
      <AvatarInfo variant="body1">{formatPhoneNumber(phone) || ""}</AvatarInfo>
      <AvatarInfo variant="body1" gutterBottom>
        {email}
      </AvatarInfo>
    </AvatarContent>
  );
}
